/* eslint-disable no-console */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-shadow */
import { useState } from 'react';
// @mui
import {
  Stack,
  Typography,
  Divider,
  Box,
  Container,
  Grid,
  Card,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
// components
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import Alert from '@mui/material/Alert';
import axiosInstance from '../utils/axiosInstance';
import SensorInfo from '../components/sensor-info/sensorInfo';
import SensorNetworkInfo from '../components/sensor-network-info/sensorNetworkInfo';
import SingleSelector from '../components/single-selector/singleSelector';

export default function SensorDetails() {
  const { adaptorType } = window;
  const { enqueueSnackbar } = useSnackbar();
  const [sensor, setSensor] = useState(null);
  const [sensorInfo, setSensorInfo] = useState(null);
  const [sensorNetwork, setSensorNetwork] = useState(null);
  const [infoFetchStatus, setInfoFetchStatus] = useState('uninitialized');
  const [networkFetchStatus, setNetoworkFetchStatus] = useState('uninitialized');
  const sensorList = useSelector((state) => state.app.sensorList);

  const fetchSensorDetails = (sensor) => {
    if (!sensor) {
      return;
    }
    setInfoFetchStatus('pending');
    axiosInstance
      .get(
        `${window.location.protocol}//${sensor.host}/api/v1/sensor/${sensor.sensorId}/info`,{ headers: { "streamId": sensor.sensorId } }
      )
      .then(async (response) => {
        setInfoFetchStatus('success');
        console.debug('fetchInfo response: ', response.data);
        setSensorInfo(response.data);
      })
      .catch((error) => {
        setInfoFetchStatus('error');
        if (error.response.data == null) {
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        } else {
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        }
      });

    if (adaptorType !== 'mms') {
      setNetoworkFetchStatus('pending');
      axiosInstance
        .get(
          `${window.location.protocol}//${sensor.host}/api/v1/sensor/${sensor.sensorId}/network`,{ headers: { "streamId": sensor.sensorId } }
        )
        .then(async (response) => {
          setNetoworkFetchStatus('success');
          console.debug('fetchNetwork response: ', response.data);
          setSensorNetwork(response.data);
        })
        .catch((error) => {
          setNetoworkFetchStatus('error');
          if (error.response.data == null) {
            enqueueSnackbar(`Error - ${error.response.status}`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
          } else {
            enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
              variant: 'error',
              anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
            });
          }
        });
    }
  };

  const handleSensorSelect = (cam) => {
    setSensor(cam);
    fetchSensorDetails(cam);
    if (!cam) {
      setSensorInfo(null);
      if (adaptorType !== 'mms') {
        setSensorNetwork(null);
      }
    }
  };

  // Function to filter authorized sensors
  const filterAuthorized = (sensorList) => sensorList
    .filter((sensor) => sensor.isAuthorized === true);

  const sensorInfoPresent = sensor != null && sensorInfo != null;
  const networkInfoPresent = sensor != null && sensorNetwork != null;

  return (
    <>
      <Helmet>
        <title> Sensor details </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Sensor Info and network details
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <SingleSelector
                    id="sensor-details"
                    placeholder="Type to search"
                    label="Select sensor"
                    value={sensor}
                    onChange={handleSensorSelect}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={filterAuthorized(sensorList)}
                  />
                  {sensor != null
                    && sensorInfo != null
                    && infoFetchStatus !== 'pending' && (
                      <Alert severity="success">{`Sensor info found for ${sensor.name}`}</Alert>
                    )}
                  {sensor != null
                    && sensorNetwork != null
                    && infoFetchStatus !== 'pending'
                    && adaptorType !== 'mms' && (
                      <Alert severity="success">{`Network info found for ${sensor.name}`}</Alert>
                    )}
                  {sensor != null
                    && sensorInfo == null
                    && networkFetchStatus !== 'pending' && (
                      <Alert severity="error">{`Failed to get sensor info for ${sensor.name}`}</Alert>
                    )}
                  {sensor != null
                    && sensorNetwork == null
                    && networkFetchStatus !== 'pending'
                    && adaptorType !== 'mms' && (
                      <Alert severity="error">{`Failed to get network info for ${sensor.name}`}</Alert>
                    )}
                </Stack>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={adaptorType === 'mms' ? 12 : 6}>
            <Card>
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <Divider sx={{ my: 2 }}>
                    <Typography variant="h5" sx={{ color: 'text.secondary' }}>
                      Sensor details
                    </Typography>
                  </Divider>
                  {sensorInfoPresent && (
                    <SensorInfo
                      sensor={sensor}
                      sensorInfo={sensorInfo}
                      key={`${sensorInfo.sensorId}_info`}
                    />
                  )}
                </Stack>
              </Box>
            </Card>
          </Grid>
          {adaptorType !== 'mms' && (
            <Grid item xs={12} sm={12} md={6}>
              <Card>
                <Box sx={{ p: 3 }}>
                  <Stack spacing={3} sx={{ mb: 2 }}>
                    <Divider sx={{ my: 2 }}>
                      <Typography variant="h5" sx={{ color: 'text.secondary' }}>
                        Network details
                      </Typography>
                    </Divider>
                    {networkInfoPresent && (
                      <SensorNetworkInfo
                        sensor={sensor}
                        networkInfo={sensorNetwork}
                        key={`${sensorNetwork.ipAddressV4 + sensorNetwork.ipAddressV6
                          }`}
                      />
                    )}
                  </Stack>
                </Box>
              </Card>
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
}
